// AUTO-GENERATED. DO NOT EDIT.
// Source: scripts/i18n/generate_i18n_catalogs.mjs

export const commonErrorApiCodeCtf = {
  ctfAuthMemberAccessRequired: "当前 SSO 身份没有对应的 CTF 成员",
  ctfAuthMemberInactive: "对应的 CTF 成员不是 active 状态",
  ctfMemberNotFound: "CTF 成员 {member_id} 不存在",
  ctfMemberUserIdRequired: "CTF 成员请求缺少 user_id",
  ctfMemberUsernameRequired: "CTF 成员请求缺少用户名",
  ctfMemberDuplicateUserId: "请求中重复出现 CTF 成员 user_id {user_id}",
  ctfMemberAlreadyExists: "CTF 成员已存在：{user_ids}",
  ctfMemberInvalidRoles: "CTF 成员角色无效",
  ctfPlatformApplicationNotFound: "CTF 平台应用 {app_key} 不存在",
  ctfPlatformDataContractInvalid: "CTF 平台数据合同无效：{field_name}，{reason}",
  ctfBusinessEventInboxRetryLater: "CTF 事件正在等待稍后重试",
  ctfBusinessEventUnexpectedRetryableFailure: "CTF 事件处理遇到可重试失败",
} as const;
